import { useMemo } from "react";
import {
  getMaintenanceCapabilities,
  getMaintenanceRole,
  type MaintenanceCapabilities,
  type MaintenanceRole,
} from "../roles";

// Resolves the active maintenance persona and its capability matrix once per
// mount. Sections use this to gate CRUD/charge actions instead of checking role
// strings inline. Reads localStorage, so it is stable for the component's life.
export function useMaintenanceCapabilities(): {
  role: MaintenanceRole;
  capabilities: MaintenanceCapabilities;
} {
  return useMemo(() => {
    const role = getMaintenanceRole();
    return { role, capabilities: getMaintenanceCapabilities(role) };
  }, []);
}
